import{useContext}from"react";import{SSRContext}from"../providers/ssrProvider";export var useIsSSR=function useIsSSR(){return useContext(SSRContext);};